import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Box, Modal } from "@mui/material";
import { ForceCloseIcon } from "../../../../assets/CommonAssets";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import InputField from "../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import {
  getComplaintCategoryDropDown,
  getComplaintServicesFindById,
  saveComplaintCategory,
} from "../../../services/complaintServices/ComplaintServicesServices";
import { CapitalizeStatement } from "../../../../common/components/Custom Hooks/CapitalizeStatement";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import {
  saveComplaintServices,
  UpdateComplaintServices,
} from "../../../services/complaintServices/ComplaintServicesServices";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import { getDepartmentDropDown } from "../../../services/feedback/feedbackcreate/FeedBackCreationServices";
const genders = [
  { id: 1, label: "Minute", value: "Minute" },
  { id: 2, label: "Hours", value: "Hours" },
  { id: 3, label: "Days", value: "Days" },
];
const complaintCatagoryOption = [
  {
    label: "Reception",
    value: "Reception",
    id: 6,
  },
  {
    value: "Physiotherapy",
    id: 7,
    label: "Physiotherapy",
  },
  {
    id: 8,
    value: "Casualty",
    label: "Casualty",
  },
  {
    id: 9,
    label: "I V F",
    value: "I V F",
  },
  {
    id: 10,
    label: "Cath Lab",
    value: "Cath Lab",
  },
  {
    id: 11,
    value: "Ecg / Emm",
    label: "Ecg / Emm",
  },
  {
    label: "Endoscopy",
    value: "Endoscopy",
    id: 12,
  },
  {
    value: "Urology",
    label: "Urology",
    id: 13,
  },
  {
    label: "E N T",
    id: 14,
    value: "E N T",
  },
  {
    id: 15,
    label: "Opthalmology",
    value: "Opthalmology",
  },
  {
    id: 16,
    label: "Gynaecology",
    value: "Gynaecology",
  },
  {
    value: "Dermatology",
    id: 17,
    label: "Dermatology",
  },
  {
    label: "Peadiatrics",
    value: "Peadiatrics",
    id: 18,
  },
  {
    label: "Oncology",
    value: "Oncology",
    id: 19,
  },
  {
    label: "Nephrology",
    id: 20,
    value: "Nephrology",
  },
  {
    label: "ORTHOPAEDICS",
    id: 21,
    value: "ORTHOPAEDICS",
  },
  {
    value: "Psychiatry",
    label: "Psychiatry",
    id: 22,
  },
  {
    label: "Medician",
    value: "Medician",
    id: 23,
  },
  {
    id: 24,
    value: "General Surgeon",
    label: "General Surgeon",
  },
  {
    id: 25,
    value: "Endocrinology",
    label: "Endocrinology",
  },
  {
    id: 26,
    value: "Cardiology",
    label: "Cardiology",
  },
  {
    id: 27,
    label: "Diabetology",
    value: "Diabetology",
  },
  {
    id: 28,
    label: "Neurology",
    value: "Neurology",
  },
  {
    id: 29,
    value: "Gastroenterology",
    label: "Gastroenterology",
  },
  {
    value: "Dental",
    id: 30,
    label: "Dental",
  },
  {
    id: 31,
    label: "Health Check Up",
    value: "Health Check Up",
  },
  {
    label: "Account's",
    id: 32,
    value: "Account's",
  },
  {
    id: 33,
    value: "Billing",
    label: "Billing",
  },
  {
    value: "Bio-medical",
    id: 34,
    label: "Bio-medical",
  },
  {
    value: "Chest Physician",
    label: "Chest Physician",
    id: 35,
  },
  {
    label: "Medicine",
    value: "Medicine",
    id: 36,
  },
  {
    label: "Neuro Surgery",
    value: "Neuro Surgery",
    id: 37,
  },
  {
    label: "Gen And Laparoscopic Surgeon",
    id: 38,
    value: "Gen And Laparoscopic Surgeon",
  },
  {
    label: "Onco Surgeon",
    value: "Onco Surgeon",
    id: 39,
  },
  {
    id: 40,
    value: "Laproscopic Surgeon",
    label: "Laproscopic Surgeon",
  },
  {
    id: 41,
    value: "Anesthestist",
    label: "Anesthestist",
  },
  {
    id: 42,
    label: "Haematologist",
    value: "Haematologist",
  },
  {
    id: 43,
    value: "Pharmacy",
    label: "Pharmacy",
  },
  {
    id: 44,
    label: "Rheumatologist",
    value: "Rheumatologist",
  },
  {
    id: 45,
    label: "Purchase",
    value: "Purchase",
  },
  {
    value: "Surgeon",
    id: 46,
    label: "Surgeon",
  },
  {
    label: "It & Edp",
    id: 47,
    value: "It & Edp",
  },
  {
    label: "Administration",
    id: 48,
    value: "Administration",
  },
  {
    label: "Nursing",
    id: 49,
    value: "Nursing",
  },
  {
    id: 50,
    label: "Cssd",
    value: "Cssd",
  },
  {
    label: "Maintenance",
    value: "Maintenance",
    id: 51,
  },
  {
    value: "Security",
    label: "Security",
    id: 52,
  },
  {
    label: "Plastic Surgery",
    value: "Plastic Surgery",
    id: 53,
  },
  {
    label: "UltraSonic",
    value: "UltraSonic",
    id: 54,
  },
  {
    value: "Muslim Bank",
    label: "Muslim Bank",
    id: 55,
  },
  {
    label: "Infectious Diseases",
    id: 56,
    value: "Infectious Diseases",
  },
  {
    id: 57,
    label: "Housekeeping",
    value: "Housekeeping",
  },
  {
    id: 58,
    label: "Human Resource",
    value: "Human Resource",
  },
  {
    id: 59,
    label: "Gynac Ot",
    value: "Gynac Ot",
  },
  {
    label: "Dietitian",
    value: "Dietitian",
    id: 60,
  },
  {
    id: 61,
    value: "Holistic Therapy  Dept",
    label: "Holistic Therapy  Dept",
  },
  {
    value: "Pain Clinic",
    label: "Pain Clinic",
    id: 62,
  },
  {
    id: 63,
    value: "Sexology",
    label: "Sexology",
  },
  {
    label: "C M E",
    value: "C M E",
    id: 64,
  },
  {
    label: "Vascular Surgeon",
    id: 65,
    value: "Vascular Surgeon",
  },
  {
    value: "Spine Surgery",
    label: "Spine Surgery",
    id: 66,
  },
  {
    id: 67,
    value: "Audiometry",
    label: "Audiometry",
  },
  {
    value: "Homeopathy",
    label: "Homeopathy",
    id: 68,
  },
  {
    value: "Medical Social Worker",
    label: "Medical Social Worker",
    id: 69,
  },
  {
    label: "Neonatology",
    value: "Neonatology",
    id: 70,
  },
  {
    label: "Paediatric Cardiology",
    value: "Paediatric Cardiology",
    id: 71,
  },
  {
    id: 72,
    value: "Foot Clinic",
    label: "Foot Clinic",
  },
  {
    label: "Hepato Billiary Surgeon",
    id: 73,
    value: "Hepato Billiary Surgeon",
  },
  {
    label: "X-ray",
    id: 74,
    value: "X-ray",
  },
  {
    id: 75,
    label: "Sonography",
    value: "Sonography",
  },
  {
    id: 76,
    value: "Bariatric Surgen",
    label: "Bariatric Surgen",
  },
  {
    id: 77,
    value: "Interventional Radiologist",
    label: "Interventional Radiologist",
  },
  {
    id: 78,
    value: "Major Ot",
    label: "Major Ot",
  },
  {
    value: "General Stores",
    id: 79,
    label: "General Stores",
  },
  {
    id: 80,
    label: "Surgical Gasetroenterology",
    value: "Surgical Gasetroenterology",
  },
  {
    id: 81,
    label: "Paediatric Pulmonology",
    value: "Paediatric Pulmonology",
  },
  {
    id: 82,
    value: "Ayurvedic",
    label: "Ayurvedic",
  },
  {
    value: "Cssd Nibm",
    label: "Cssd Nibm",
    id: 83,
  },
  {
    value: "Paediatric Neurology",
    label: "Paediatric Neurology",
    id: 84,
  },
  {
    label: "Wards/icu/ccu",
    value: "Wards/icu/ccu",
    id: 85,
  },
  {
    label: "Breast Care Clinic",
    id: 86,
    value: "Breast Care Clinic",
  },
  {
    label: "Oral And Maxillofacial",
    value: "Oral And Maxillofacial",
    id: 87,
  },
  {
    value: "Uro Oncology",
    id: 88,
    label: "Uro Oncology",
  },
  {
    id: 89,
    label: "Maintainance",
    value: "Maintainance",
  },
  {
    id: 90,
    value: "F & B",
    label: "F & B",
  },
  {
    id: 91,
    label: "Msw",
    value: "Msw",
  },
  {
    label: "Stores",
    value: "Stores",
    id: 92,
  },
  {
    value: "I.t.",
    label: "I.t.",
    id: 93,
  },
  {
    value: "Patient Relations",
    id: 94,
    label: "Patient Relations",
  },
  {
    id: 95,
    label: "Biomedical Engg.",
    value: "Biomedical Engg.",
  },
  {
    value: "Front Office",
    id: 96,
    label: "Front Office",
  },
  {
    label: "Business Development",
    value: "Business Development",
    id: 97,
  },
  {
    value: "Accounts/finance",
    label: "Accounts/finance",
    id: 98,
  },
  {
    id: 99,
    value: "Medical Records",
    label: "Medical Records",
  },
  {
    label: "F&b",
    value: "F&b",
    id: 100,
  },
  {
    label: "Hr",
    value: "Hr",
    id: 101,
  },
  {
    value: "Clinical Research",
    id: 102,
    label: "Clinical Research",
  },
  {
    value: "Quality",
    id: 103,
    label: "Quality",
  },
  {
    id: 104,
    value: "Fire &safety",
    label: "Fire &safety",
  },
  {
    id: 105,
    label: "Dietetics",
    value: "Dietetics",
  },
  {
    id: 106,
    label: "Wards Clinical",
    value: "Wards Clinical",
  },
  {
    id: 107,
    label: "Micu",
    value: "Micu",
  },
  {
    id: 108,
    value: "Ccu",
    label: "Ccu",
  },
  {
    label: "Gynecology & Obstetrics",
    id: 109,
    value: "Gynecology & Obstetrics",
  },
  {
    label: "Sono- Radiology",
    id: 111,
    value: "Sono- Radiology",
  },
  {
    value: "Pathology Lab",
    label: "Pathology Lab",
    id: 112,
  },
  {
    value: "Microbiology Lab",
    label: "Microbiology Lab",
    id: 113,
  },
  {
    id: 114,
    label: "Blood Storage",
    value: "Blood Storage",
  },
  {
    value: "Clinical Pharmacist",
    label: "Clinical Pharmacist",
    id: 115,
  },
  {
    label: "Consultant",
    value: "Consultant",
    id: 116,
  },
  {
    label: "Anesthesia",
    value: "Anesthesia",
    id: 117,
  },
  {
    label: "Nursing Nibm",
    id: 118,
    value: "Nursing Nibm",
  },
  {
    value: "Casualty Imh",
    label: "Casualty Imh",
    id: 119,
  },
  {
    value: "Pro",
    id: 120,
    label: "Pro",
  },
  {
    label: "Icu",
    id: 121,
    value: "Icu",
  },
  {
    id: 122,
    label: "Peadiatrics Imh",
    value: "Peadiatrics Imh",
  },
  {
    id: 123,
    value: "Gynac",
    label: "Gynac",
  },
  {
    label: "Dental Imh",
    value: "Dental Imh",
    id: 124,
  },
  {
    id: 125,
    value: "Physiotherapy Imh",
    label: "Physiotherapy Imh",
  },
  {
    id: 127,
    value: "Mri",
    label: "Mri",
  },
  {
    value: "Lactation",
    id: 128,
    label: "Lactation",
  },
  {
    label: "Dialysis",
    value: "Dialysis",
    id: 129,
  },
  {
    value: "test",
    id: 198,
    label: "test",
  },
  {
    value: "string",
    id: 199,
    label: "string",
  },
  {
    value: "department",
    id: 200,
    label: "department",
  },
  {
    id: 201,
    label: "Eye",
    value: "Eye",
  },
  {
    id: 202,
    label: "Test1",
    value: "Test1",
  },
  {
    id: 203,
    value: "test10",
    label: "test10",
  },
  {
    value: "test1",
    label: "test1",
    id: 204,
  },
  {
    value: "department",
    id: 205,
    label: "department",
  },
  {
    label: "Test 2",
    id: 206,
    value: "Test 2",
  },
  {
    id: 207,
    value: "test",
    label: "test",
  },
];
const ModalStyle = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  maxWidth: "90%",
  maxHeight: "60%",
  height: "20%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  overflowY: "visible",
  boxShadow: 20,
  p: 2,
};
export default function ComplaitServicesModel(props) {
  const defaultValues = {
    services: "",
    status: true,
    gender: "Hours",
    duration: "",
  };
  const schema = yup
    .object({
      services: yup.string().trim().required(),
      duration: yup.string().trim().required(),
      complaitCategory: yup
        .object()
        .nullable()
        .required("complaitCategory is required"),
    })
    .required();
  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [complaintCatagoryOptions, setComplaintCategoryOptions] = useState([]);
  const [putConfirmationModal, setPutConfirmationModal] = useState(false);

  const {
    reset,
    control,
    watch,
    setValue,
    register,
    clearErrors,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
    mode: "onChange",
  });
  let genderVal = watch("gender");
  let durationVal = watch("duration");

  React.useState(() => {
    // getComplaintServicesFindById
    if (props?.edit) {
      getComplaintServicesFindById(props?.row)
        .then((response) => response?.data)
        .then((res) => {
          let result = JSON.parse(res?.result);
          console.log("dfereredsdsdfsdsdsdsdf", result);
          let resetObj = {
            complaitCategory: {
              id: result?.departmentId,
              label: result?.department,
              value: result?.departmentId ,
            },
            services: result?.serviceName,
            isassetlink: result?.isAssestLink,
            status: result?.isActive,
            duration: result?.duration,
            gender: result?.tat,
          };
          reset(resetObj);
        });
    }
  }, [props?.edit]);

  const onSubmit = (data) => {
    let tempObj = {
      id: props?.edit !== null ? props?.row : null,
      department: data.complaitCategory?.id,
      serviceName: CapitalizeStatement(data.services),
      isAssetLink: data?.isassetlink,
      isActive: data.status,
      duration: durationVal,
      tat: genderVal,
    };

    console.log("kssdflksdlskdlsfkdjfskdf", tempObj);

    if (props?.edit === false) {
      setFormData(tempObj);
      console.log("uploadImageuploadImage", tempObj);
      setPostConfirmationModal(true);
    } else if (props?.edit === true) {
      setFormData(tempObj);
      setPutConfirmationModal(true);
    }
  };

  const handleSaveClick = () => {
    props.setOpenBackdrop(true);
    setPostConfirmationModal(false);
    saveComplaintServices(formData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          props?.handleClose();
          props?.populateTable();
          props?.setRow(null);
          successAlert(res.message);
          props?.setOpenBackdrop(false);
          reset(defaultValues);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        props?.setOpenBackdrop(false);
      });
    props.handleClose();
    props?.setEdit(false);
    reset(defaultValues);
  };

  const handleUpdateClick = () => {
    props.setOpenBackdrop(true);
    setPutConfirmationModal(false);
    UpdateComplaintServices(formData)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          props?.handleClose();
          props?.populateTable();
          props?.setRow(null);
          successAlert(res.message);
          props?.setOpenBackdrop(false);
          reset(defaultValues);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        props?.setOpenBackdrop(false);
      });
    props.handleClose();
    reset(defaultValues);
  };

  useEffect(() => {
    getDepartmentDropDown()
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          console.log("get all state", res?.result);
          setComplaintCategoryOptions(res?.result);
        }
        console.log("response.data.result", res?.data?.result);
      })
      .catch((error) => {
        errorAlert(error.message);
      });
  }, []);
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Box component="main" sx={{ flexGrow: 1, p: 1, width: "100%" }}>
          <Modal
            open={props?.open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={ModalStyle} className="rounded-md space-y-3">
              <div className="flex justify-between">
                <h1 className="font-bold">Complaint Services</h1>
                <button
                  onClick={() => {
                    props?.handleClose();
                    reset();
                    props?.setEdit(false);
                    props?.setRow(null);
                  }}
                >
                  <ForceCloseIcon type="button" />
                </button>
              </div>
              <CommonDivider color="#E0E0E0" />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex">
                  <div className="grid  grid-cols-7 gap-2  w-full">
                    <DropdownField
                      control={control}
                      isSearchable={true}
                      isClearable={true}
                      name="complaitCategory"
                      dataArray={complaintCatagoryOption}
                      placeholder="Complait Category"
                      menuPlacement="bottom"
                      error={errors?.complaitCategory}
                    />
                    <div className="col-span-2">
                      <InputField
                        control={control}
                        name="services"
                        label="Services Name"
                        error={errors?.services}
                      />
                    </div>
                    <InputField
                      control={control}
                      name="duration"
                      label="Duration"
                      error={errors?.duration}
                      type={"number"}
                    />
                    <div className="flex  items-center ">
                      <div className="flex gap-0 items-center">
                        {genders?.length > 0
                          ? genders.map((gender, genderIndex) => {
                              return (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setValue("gender", gender.value);
                                  }}
                                  className={`border border-gray-300 w-10 h-8 ${
                                    genderIndex === 0 ? `rounded-l` : ``
                                  } ${
                                    watch("gender") === gender.value
                                      ? `bg-customBlue text-white`
                                      : ``
                                  } ${
                                    genderIndex === genders?.length - 1
                                      ? `rounded-r`
                                      : ``
                                  } `}
                                >
                                  {gender?.label.charAt(0)}
                                </button>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                    <CheckBoxField
                      name="isassetlink"
                      label="isAssetLink"
                      control={control}
                    />
                    <CheckBoxField
                      name="status"
                      label="Active"
                      control={control}
                    />
                  </div>
                  <div className="flex justify-end gap-2">
                    <CommonButton
                      label="Reset"
                      type="button"
                      onClick={() => {
                        reset(defaultValues);
                      }}
                      className="bg-white text-[#D11A2A] border border-[#D11A2A]"
                    />
                    <CommonButton
                      label={props?.edit ? "Update" : "Save"}
                      type="submit"
                      className="bg-[#368505] text-white"
                    />
                  </div>
                </div>
              </form>
            </Box>
          </Modal>
          {postConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={postConfirmationModal}
              confirmationHandleClose={() => setPostConfirmationModal(false)}
              confirmationSubmitFunc={handleSaveClick}
              confirmationMsg={`Are you sure you want to ${
                props?.edit ? "Update" : "Save"
              } this Record?`}
              confirmationButtonMsg={"Save"}
              confirmationLabel={"Save"}
            />
          )}

          {putConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={putConfirmationModal}
              confirmationHandleClose={() => setPutConfirmationModal(false)}
              confirmationSubmitFunc={handleUpdateClick}
              confirmationMsg={`Are you sure you want to ${
                props?.editData ? "Update" : "Add"
              } this Record?`}
              confirmationButtonMsg={"Update"}
              confirmationLabel={"Update"}
            />
          )}
        </Box>
      </Box>
    </div>
  );
}
